<div class="container single-view" id="add-inventory">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" href="javascript:void(0)" appBack fallbackUrl="/inventories" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'INVENTORIES.BTN_BACK_TO_INVENTORY' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr">
          <h1 data-testid="add-inventory-title" class="section-title">{{ 'INVENTORY_CREATE.TITLE' | translate }}</h1>
          <p data-testid="edit-inventory-subtitle" class="section-subtitle mt-1 text-base">{{ 'INVENTORY_CREATE.SUBTITLE' | translate }}</p>
        </div>
        <div class="actions-wr"></div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <form class="mt-0" [formGroup]="inventoryForm" data-testid="add-inventory-form">
              <div class="row">
                <div class="flex flex-col col-12 mb-4">
                  <h2 data-testid="edit-inventory-details" class="border-b pb-3">{{ 'INVENTORY_CREATE.INVENTORY_DETAILS' | translate }}</h2>
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-inventory-field-reference" class="block text-sm" for="reference">{{ 'INVENTORY_CREATE.INVENTORY_REFERENCE' | translate
                    }} <i class="icon-required-field"></i></label>
                    <input data-testid="add-inventory-reference-input" type="text" id="reference" formControlName="reference" autocomplete="off">
                    @if (inventoryForm.get('reference')?.invalid && inventoryForm.get('reference')?.touched) {
                      <small data-testid="reference-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                    }
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="add-inventory-field-retailer" class="block text-sm" for="retailerId">{{ 'INVENTORY_CREATE.RETAILER' | translate }} <i class="icon-required-field"></i></label>
                    <app-custom-dropdown
                      data-testid="retailer"
                      [placeholder]="'SALE_UPDATE.SELECT_RETAILER' | translate"
                      optionLabel="text"
                      optionValue="id"
                      [isMultiselect]="false"
                      [showSelectionChips]="true"
                      [showClear]="true"
                      [searchMode]="'remote'"
                      [pageSize]="combosData['retailers'].rowsPerPageOption || 5"
                      [totalCount]="combosData['retailers'].totalRecords"
                      [totalPages]="getComboTotalPages('retailers')"
                      [options]="combosData['retailers'].list"
                      formControlName="retailerId"
                      (onLazyLoad)="onLazyLoadComboData('retailers',$event)">
                    </app-custom-dropdown>
                    @if (inventoryForm.get('retailerId')?.invalid && inventoryForm.get('retailerId')?.touched) {
                      <small data-testid="retailer-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                    }
                  </div>
                  @if (!hasOnlyOneActiveBrand) {
                    <div [ngClass]="{ 'disabled': !inventoryForm.controls['retailerId'].value?.length  }" class="field-wr flex flex-col col-12 col-sm-12 col-md-3 col-lg-6 col-xl-3">
                      <label data-testid="add-inventory-field-brand" class="block text-sm" for="brandId">
                        {{ 'INVENTORY_CREATE.BRAND' | translate }} <i class="icon-required-field"></i>
                      </label>
                      <app-custom-dropdown
                        data-testid="productbrand"
                        [placeholder]="'INVENTORY_CREATE.SELECT_BRAND' | translate"
                        optionLabel="text"
                        optionValue="id"
                        [isMultiselect]="false"
                        [showSelectionChips]="true"
                        [showClear]="!hasOnlyOneActiveBrand"
                        [searchMode]="'remote'"
                        [pageSize]="combosData['brands'].rowsPerPageOption || 5"
                        [totalCount]="combosData['brands'].totalRecords"
                        [totalPages]="getComboTotalPages('brands')"
                        [options]="combosData['brands'].list"
                        formControlName="brandId"
                        (onLazyLoad)="onLazyLoadComboData('brands', $event)">
                      </app-custom-dropdown>
                    </div>
                  }
                  <div class="field-wr flex flex-col col-12">
                    <label data-testid="add-inventory-field-comments" class="block text-sm" for="comment">{{ 'INVENTORY_CREATE.COMMENTS' | translate }}</label>
                    <textarea data-testid="add-inventory-comments-input" type="text" id="comment" formControlName="comment" autocomplete="off"></textarea>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mt-6 mb-4 pt-8 border-t">
                    <div class="flex items-center justify-end gap-3">
                      <button data-testid="add-inventory-create-inventory-button" class="btn primary-btn" [disabled]="inventoryForm.invalid"
                      (click)="submitForm()">{{ 'INVENTORY_CREATE.BTN_ADD_NEW_INVENTORY' | translate }}</button>
                    </div>
                  </div>
                </div>
              </form>
              <!-- /main content -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
